export const waterData = [
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Fwater.png?alt=media&token=7cd24644-20f4-4002-a53a-ae33a65ce783",
  },
//   {
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Fwater.png?alt=media&token=cdf76e56-7459-4066-bdda-ce21c113d6dd",
//   },
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2FwaterJar.png?alt=media&token=91fdc415-89e3-45e0-b29b-bfcad896e109",
  },
];
